import { useSyncExternalStore } from 'react';

/**
 * Subscribes to URL changes and returns the value of the given query parameter.
 */
export const useQueryParam = (key: string): string | null => {
  return useSyncExternalStore(
    (callback) => {
      window.addEventListener('popstate', callback);
      return () => window.removeEventListener('popstate', callback);
    },
    () => new URLSearchParams(window.location.search).get(key),
    () => null,
  );
};
